<div class="d-flex column h-100" cdkTrapFocus>
  <div class="flex-0 medium" mat-dialog-title>
    <div class="row h-100 ai-center blue-header no-wrap">
      <div class="col-8 d-flex">
        <img src="../../../../assets/icons/incomm_logo.svg" class="incomm-logo mr-hq" alt="InComm" />
        <div class="flex-1 mw-400 d-flex column">
          <div class="title-label">{{ 'common.approval-manager.request-name' | translate | uppercase }}</div>
          <div class="title-request-name truncate mt-h" data-test-id="appr_mgr_req_name" [attr.title]="requestName">
            {{ requestName }}
          </div>
        </div>
        <div class="icon icon-arrow-down rotate-270 opacity-60"></div>
        <div class="flex-1 mw-400" *ngIf="requestItems && selectedRequestItem">
          <div class="title-label pl-h">{{ 'common.approval-manager.select-item' | translate | uppercase }}</div>
          <button
            class="menu-button blue truncate mw-400"
            mat-button
            [matMenuTriggerFor]="itemSelectMenu"
            data-test-id="appr_mgr_artwork_select_btn"
          >
            <span class="flex-1 jc-start fs-md medium truncate" [attr.title]="getRequestItemLabel(selectedRequestItem)">
              {{ getRequestItemLabel(selectedRequestItem) }}
            </span>
            <span class="icon icon-arrow-down ml-h"></span>
          </button>
          <mat-menu #itemSelectMenu="matMenu" data-test-id="appr_mgr_select_req_item">
            <button
              class="menu-item-button"
              *ngFor="let item of requestItems; let i = index"
              mat-menu-item
              (click)="setSelectedRequestItem(item)"
              [attr.data-test-id]="['approval_manager_select_item', i].join('_')"
              [attr.title]="getRequestItemLabel(item)"
            >
              <span class="truncate">{{ getRequestItemLabel(item) }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="col-3">
        <div class="h-100 fs-xs counters d-flex jc-end px-2" *ngIf="isApproval()" data-test-id="appr_mgr_req_item_counters">
          <ng-container *ngTemplateOutlet="requestItemCounters; context: {counter: countRequestItems()}"></ng-container>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="closeModalButton; context: {counter: countRequestItems()}"></ng-container>
    </div>
    <div class="d-flex version-area">
      <div class="pl-1 d-flex column jc-around" *ngIf="selectedArtwork && !comparisonOn">
        <ng-container *ngTemplateOutlet="artworkSelect"></ng-container>
      </div>
      <div
        class="px-1 d-flex"
        *ngIf="selectedVersion"
        [ngClass]="{'flex-1 jc-center': comparisonOn}"
        style="max-width: 100%; min-width: 140px; flex: 1 1 280px;"
      >
        <ng-container *ngTemplateOutlet="versionSelect"></ng-container>
      </div>
      <div class="d-flex ai-end pb-e" *ngIf="isApproval() && !comparisonOn && canReviewSelectedArtwork">
        <ng-container *ngTemplateOutlet="approvalButtons"></ng-container>
      </div>
      <div class="d-flex ai-end pb-e">
        <ng-container *ngTemplateOutlet="reviewComments"></ng-container>
      </div>
      <div class="flex-1" *ngIf="!comparisonOn"></div>
      <div class="flex-0 compare-to jc-center d-flex column fs-xs medium" *ngIf="comparisonOn" data-test-id="appr_mgr_comparison_delimeter">
        <div>{{ 'common.approval-manager.compare-to' | translate | uppercase }}</div>
        <div class="icon icon-compare mt-e"></div>
      </div>
      <div
        class="px-1 d-flex"
        *ngIf="comparisonOn && compareVersion"
        [ngClass]="{'flex-1 jc-end': comparisonOn}"
        [style.padding-left]="comparisonOn ? '78px' : '0'"
        style="max-width: 100%; min-width: 140px; flex: 1 1 280px;"
      >
        <ng-container *ngTemplateOutlet="compareVersionSelect"></ng-container>
      </div>
      <div *ngIf="isRestrictionSizeWarningExist" class="action-button-wrapper relative">
        <ng-container *ngTemplateOutlet="sizeRestrictionMessage"></ng-container>
      </div>
      <div class="button-spacer" *ngIf="isRestrictionSizeWarningExist"></div>
      <div class="action-button-wrapper" *ngIf="!comparisonOn && canUploadSelectedArtwork">
        <ng-container *ngTemplateOutlet="uploadVersionButton"></ng-container>
      </div>
      <div class="button-spacer" *ngIf="!comparisonOn"></div>
      <div class="action-button-wrapper" *ngIf="!comparisonOn">
        <ng-container *ngTemplateOutlet="downloadOptionsButton"></ng-container>
      </div>
      <div class="button-spacer" *ngIf="!comparisonOn"></div>
      <div class="action-button-wrapper" [ngClass]="{'flex-0': comparisonOn, 'px-1e': comparisonOn}">
        <ng-container *ngTemplateOutlet="comparisonButtons"></ng-container>
      </div>
    </div>
  </div>
  <div class="flex-1" mat-dialog-content></div>
</div>

<ng-template #approvalButtons>
  <div class="d-flex row no-wrap" [ngSwitch]="getLatestResolution(selectedVersion).status">
    <ng-template [ngSwitchCase]="ARTWORK_STATUSES.approved">
      <button
        class="button link-secondary d-flex ai-center approval-link px-e"
        data-test-id="appr_mgr_cancel_approval_btn"
        (click)="review(selectedVersion, ARTWORK_STATUSES.unreviewed)"
      >
        <span class="icon icon-close"></span>
        {{ 'common.button.cancel-approval' | translate }}
      </button>
    </ng-template>

    <ng-template [ngSwitchCase]="ARTWORK_STATUSES.rejected">
      <button
        class="button link-secondary d-flex ai-center approval-link px-e"
        data-test-id="appr_mgr_cancel_rejection_btn"
        (click)="review(selectedVersion, ARTWORK_STATUSES.unreviewed)"
      >
        <span class="icon icon-close"></span>
        {{ 'common.button.cancel-rejection' | translate }}
      </button>
    </ng-template>

    <ng-template [ngSwitchCase]="ARTWORK_STATUSES.unreviewed">
      <button
        class="button primary-button d-flex ai-center medium mr-1"
        data-test-id="appr_mgr_approve_btn"
        (click)="review(selectedVersion, ARTWORK_STATUSES.approved)"
      >
        {{ 'common.button.step-approve' | translate }}
      </button>
      <button
        class="button secondary-reject-button d-flex ai-center medium reject"
        data-test-id="appr_mgr_reject_btn"
        (click)="review(selectedVersion, ARTWORK_STATUSES.rejected)"
      >
        <span class="icon icon-close"></span>
        {{ 'common.button.reject' | translate }}
      </button>
    </ng-template>
  </div>
</ng-template>

<ng-template #reviewComments>
  <div
    class="d-flex row approval-link"
    *ngIf="getLatestResolution(selectedVersion).status !== ARTWORK_STATUSES.unreviewed && !comparisonOn"
  >
    <span
      class="d-flex ai-center fs-sm medium"
      [ngClass]="getLatestResolution(selectedVersion).status === ARTWORK_STATUSES.approved ? 'color-green' : 'color-error'"
      *ngIf="getLatestVersionComment(selectedVersion) as comment"
      appTooltip
      [tooltipText]="comment"
      customClass="ng-tooltip-fixed"
      position="bottom"
    >
      <span class="vertical-delimeter mx-1" *ngIf="isApproval() && !comparisonOn && canReviewSelectedArtwork"></span>
      <span class="icon icon-info icon-fs-base mr-q"></span>
      <span
        [translate]="
          getLatestResolution(selectedVersion).status === ARTWORK_STATUSES.approved
            ? 'common.approval-manager.see-approval-comment'
            : 'common.approval-manager.see-rejection-comment'
        "
      ></span>
    </span>
  </div>
</ng-template>

<ng-template #comparisonButtons>
  <button
    class="link-secondary action-button"
    (click)="toggleComparison()"
    *ngIf="!comparisonOn; else finishComparison"
    data-test-id="appr_mgr_compare"
  >
    <span class="icon icon-compare mr-h"></span>
    {{ 'common.button.compare' | translate }}
  </button>
  <ng-template #finishComparison>
    <button class="button secondary-button" data-test-id="appr_mgr_compare_finish" (click)="toggleComparison()">
      {{ 'common.button.finish' | translate }}
    </button>
  </ng-template>
</ng-template>

<ng-template #downloadOptionsButton>
  <button class="link-secondary action-button" mat-button [matMenuTriggerFor]="downloadOptionsMenu" data-test-id="appr_mgr_download_options_btn">
    {{ 'common.button.download-options' | translate }}
    <span class="icon icon-arrow-down"></span>
  </button>
  <mat-menu #downloadOptionsMenu="matMenu" data-test-id="appr_mgr_download_options_menu">
    <button mat-menu-item data-test-id="appr_mgr_current_version_download_btn" [matMenuTriggerFor]="downloadMenu">
      <span>{{ 'common.button.download-current-version' | translate }}</span>
    </button>
    <button mat-menu-item data-test-id="appr_mgr_all_versions_download_btn" [matMenuTriggerFor]="downloadAllMenu">
      <span>{{ 'common.button.download-all-version' | translate }}</span>
    </button>
    <button mat-menu-item data-test-id="appr_mgr_latest_rejections_download_btn" [matMenuTriggerFor] = "latestRejectionsDownloadMenu" [disabled]="latestRejectedVersions.length < 1">
      <span>{{ 'common.button.latest-rejections-download' | translate }}</span>
    </button>
  </mat-menu>
  <mat-menu #downloadMenu="matMenu" data-test-id="appr_mgr_download_menu">
    <button mat-menu-item data-test-id="appr_mgr_download_original" (click)="downloadSelectedVersion()">
      {{ 'common.approval-manager.original-file' | translate }}
    </button>
    <button mat-menu-item data-test-id="appr_mgr_download_annotated" (click)="downloadSelectedVersionWithAnnotations()">
      {{ 'common.approval-manager.annotated-file' | translate }}
    </button>
  </mat-menu>
  <mat-menu #downloadAllMenu="matMenu" data-test-id="appr_mgr_download_all_menu">
    <button mat-menu-item data-test-id="appr_mgr_download_original_files" (click)="downloadAllVersions()">
      {{ 'common.approval-manager.original-files' | translate }}
    </button>
    <button mat-menu-item data-test-id="appr_mgr_download_annotated_files" (click)="downloadAllVersionsWithAnnotations()">
      {{ 'common.approval-manager.annotated-files' | translate }}
    </button>
  </mat-menu>
  <mat-menu #latestRejectionsDownloadMenu="matMenu" data-test-id="appr_mgr_latest_rejections_download_menu">
    <button mat-menu-item data-test-id="appr_mgr_latest_rejections_download_original_files" (click)="downloadLatestRejectionsVersions()">
      {{ 'common.approval-manager.original-files' | translate }}
    </button>
    <button mat-menu-item data-test-id="appr_mgr_latest_rejections_download_annotated_files" (click)="downloadLatestRejectionsVersionsWithAnnotations()">
      {{ 'common.approval-manager.annotated-files' | translate }}
    </button>
  </mat-menu>
</ng-template>

<ng-template #artworkSelect>
  <div class="fs-xs my-e medium" style="min-width: 196px">
    <span class="counter">{{ countFilesToApprove(artworkFiles) }} / {{ artworkFiles.length }}</span>
    {{ 'common.approval-manager.files-to-approve' | translate }}
  </div>
  <button class="menu-button" mat-button [matMenuTriggerFor]="artworkSelectMenu" data-test-id="appr_mgr_artwork_select_btn">
    <span class="flex-1 jc-start fs-sm medium my-3px truncate"
     [attr.title]="['Artwork', selectedArtworkFileIndex + 1, '-', getCurrentVersion(selectedArtwork)?.attachment.fileName] | join : ' '"
     [attr.data-test-id]="[testId, 'artwork_selection', 'toggle'] | join">
      Artwork {{ selectedArtworkFileIndex + 1 }}
    </span>
    <span class="icon icon-arrow-down ml-h"></span>
  </button>
  <mat-menu #artworkSelectMenu="matMenu" data-test-id="appr_mgr_select_artwork" class="approval-manager-menu-overlay">
    <button
      class="menu-item-button"
      *ngFor="let file of artworkFiles; let artworkFileIndex = index"
      mat-menu-item
      (click)="setSelectedArtworkFile(file)"
      data-test-id="appr_mgr_select_artwork_btn"
      style="width: 100%; max-width: 460px;"
    >
      <span class="truncate" [attr.title]="['Artwork', artworkFileIndex + 1, '-', getCurrentVersion(file)?.attachment?.fileName] | join : ' '">
        Artwork {{ artworkFileIndex + 1 }}
        <ng-container *ngIf="getCurrentVersion(file)"> - ({{ getCurrentVersion(file).attachment.fileName }})</ng-container>
      </span>
    </button>
  </mat-menu>
</ng-template>

<ng-template #versionSelect>
  <div class="flex-1 d-flex column jc-around" style="min-width: 196px; max-width: 100%; flex: 0 1 auto">
    <div class="fs-xs my-e jc-start medium">{{ 'common.approval-manager.version' | translate }}:</div>
    <div class="d-flex" style="max-width: 520px;">
      <button
        class="menu-button version-button"
        mat-button
        [matMenuTriggerFor]="versionSelectMenu"
        data-test-id="appr_mgr_version_select_btn"
      >
        <ng-container
          *ngTemplateOutlet="
            versionTemplate;
            context: {version: selectedVersion, index: versions.length - versions.indexOf(selectedVersion)}
          "
        ></ng-container>
        <span class="icon icon-arrow-down ml-h"></span>
      </button>
      <mat-menu #versionSelectMenu="matMenu" data-test-id="appr_mgr_select_version" class="approval-manager-menu-overlay">
        <button
          class="menu-item-button"
          *ngFor="let version of versions; index as i"
          [value]="version"
          mat-menu-item
          (click)="setSelectedVersion(version)"
          data-test-id="appr_mgr_select_version_btn"
          style="width: 100%; max-width: 460px;"
        >
          <ng-container *ngTemplateOutlet="versionTemplate; context: {version: version, index: versions.length - i}"></ng-container>
        </button>
      </mat-menu>
    </div>
  </div>
</ng-template>

<ng-template #compareVersionSelect>
  <div class="flex-1 d-flex column jc-around" style="min-width: 196px; max-width: 100%; flex: 0 1 auto">
    <div class="fs-xs my-e jc-start medium">{{ 'common.approval-manager.version' | translate }}:</div>
    <div class="d-flex" style="max-width: 520px;">
      <button
        class="menu-button version-button"
        mat-button
        [matMenuTriggerFor]="compareVersionSelectMenu"
        data-test-id="appr_mgr_version_select_btn"
      >
        <ng-container
          *ngTemplateOutlet="versionTemplate; context: {version: compareVersion, index: versions.length - versions.indexOf(compareVersion)}"
        ></ng-container>
        <span class="icon icon-arrow-down ml-h"></span>
      </button>
      <mat-menu #compareVersionSelectMenu="matMenu" data-test-id="appr_mgr_select_compare_version" class="approval-manager-menu-overlay">
        <button
          class="menu-item-button"
          *ngFor="let version of versions; index as i"
          [value]="version"
          data-test-id="appr_mgr_select_compare_version_btn"
          mat-menu-item
          (click)="setCompareVersion(version)"
          style="width: 100%; max-width: 460px;"
        >
          <ng-container *ngTemplateOutlet="versionTemplate; context: {version: version, index: versions.length - i}"></ng-container>
        </button>
      </mat-menu>
    </div>
  </div>
</ng-template>

<ng-template #uploadVersionButton>
  <label class="link-secondary action-button truncate" data-test-id="appr_mgr_upload_version">
    <span class="icon icon-upload-version mr-h"></span>
    {{ 'common.approval-manager.upload-version' | translate }}
    <input
      type="file"
      hidden
      [accept]="fileTypesToAccept"
      (change)="uploadVersion($event.target.files[0])"
      [attr.data-test-id]="['approval_manager', 'input_file'].join('_')"
    />
  </label>
</ng-template>

<ng-template let-version="version" let-index="index" #versionTemplate>
  <span
    class="flex-1 jc-start fs-sm medium"
    [attr.title]="['common.approval-manager.version' | translate, index, '-', version.attachment.fileName] | join : ' '"
    style="max-width: 100%; min-width: 0"
  >
    <app-truncate-middle>
      {{ version.attachment.fileName }}
    </app-truncate-middle>
  </span>
  <p class="row w-100 color-navi fs-xs flex-0 my-q ml-q">
    <span class="medium version-status" [ngClass]="getLatestResolution(version).status">
      <ng-container *ngIf="index">V{{ index }}-</ng-container>{{ getLatestResolution(version).status }}
    </span>
  </p>
</ng-template>

<ng-template let-counter="counter" #requestItemCounters>
  <span [matBadge]="counter.inProgress" matBadgePosition="after" class="d-flex row ai-center no-wrap">In&nbsp;Progress</span>
  <span [matBadge]="counter.approved" matBadgePosition="after" class="d-flex row ai-center ml-2 no-wrap">Approved</span>
  <span [matBadge]="counter.rejected" matBadgePosition="after" class="d-flex row ai-center ml-2 no-wrap">Rejected</span>
</ng-template>

<ng-template let-counter="counter" #closeModalButton>
  <button type="button" class="button col-1 title-request-item close-button d-flex ai-center h-100 jc-center"
    (click)="close()" data-test-id="appr_mgr_btn_close"
    *ngIf="(counter.inProgress && isApproval()) || (!isApproval())">
    <span class="mr-h">{{ 'common.button.close' | translate }}</span>
    <span class="icon icon-close"></span>
  </button>
  <button type="button" class="button col-1 title-request-item close-button d-flex ai-center h-100 jc-center"
    (click)="close(counter.rejected)" data-test-id="appr_mgr_btn_submit" *ngIf="!counter.inProgress && isApproval()">
    <span class="mr-h">{{ counter.rejected ? ('common.button.step-back' | translate) : ('common.button.step-submit' | translate) }}</span>
    <span class="icon icon-close"></span>
  </button>
</ng-template>

<ng-template #sizeRestrictionMessage>
  <div class="d-flex ai-center color-warning h-36">
    <span class="icon icon-warning fs-md"></span>
    <span class="ml-q fs-sm">
      {{ 'common.restrictions.file-size-exceeded' | translate : {size: restrictionOptions.sizeNumber + restrictionOptions.sizeType} }}
    </span>
  </div>
</ng-template>
